module.exports = __webpack_public_path__ + "img/edi-1.03fb6dd7.png";